export enum EExportStatus {
	IN_PROGRESS = 'IN_PROGRESS',
	PROCESSED = 'PROCESSED',
	FAILED = 'FAILED',
}

export enum ELocationType {
	HUB = 'HUB',
	WAREHOUSE = 'WAREHOUSE',
	OFFICE = 'OFFICE',
	RESIDENCE = 'RESIDENCE',
	PORT = 'PORT',
	AIRPORT = 'AIRPORT',
}

export enum EOffsetPolicy {
	NEVER = 'NEVER',
	ALWAYS = 'ALWAYS',
	ON_DEMAND = 'ON_DEMAND',
}

export enum ECreationMethod {
	MANUAL = 'MANUAL',
	SCRIPT = 'SCRIPT',
	FILE = 'FILE',
	API = 'API',
}

export enum EPlatformRole {
	USER = 'USER',
	STAFF = 'STAFF',
	ADMIN = 'ADMIN',
	SUPERADMIN = 'SUPERADMIN',
}

export enum EOrganizationRole {
	USER = 'USER',
	STAFF = 'STAFF',
	ADMIN = 'ADMIN',
}

export enum EEntityRole {
	STAFF = 'STAFF',
	ADMIN = 'ADMIN',
}

export enum ETokenType {
	AUTH = 'AUTH',
	API = 'API',
}

export enum ETokenScope {
	READ = 'READ',
	WRITE = 'WRITE',
	EXECUTE = 'EXECUTE',
}

export enum ETokenDisc {
	USER = 'UsrAPIToken',
	ORGANIZATION = 'OrgAPIToken',
	ENTITY = 'EntAPIToken',
}

export enum EAuthLevel {
	PLATFORM = 'PLATFORM',
	ORGANIZATION = 'ORGANIZATION',
	ENTITY = 'ENTITY',
}

export enum EProductionUnit {
	KWH = 'KWH',
	KG = 'KG',
	ITEM = 'ITEM',
}

export enum EProjectType {
	MEASURABILITY = 'Measurability',
	ADDITIONALITY = 'Additionality',
}

export enum EEntityType {
	BRAND = 'Brand',
	PRODUCER = 'Producer',
}

export enum EMediaDisc {
	PRIVATE = 'PrivateMedia',
	PUBLIC = 'PublicMedia',
}

export enum ELanguages {
	EN = 'en',
	FR = 'fr',
}

export enum EProductionQuantityCheck {
	OK = 'OK',
	UNDER_RANGE = 'UNDER_RANGE',
	OVER_RANGE = 'OVER_RANGE',
}

export enum EExportType {
	PRODUCTION_LIST = 'PRODUCTION_LIST',
}

export enum EImportType {
	PRODUCTIONS = 'PRODUCTIONS',
}

export enum EBlockchain {
	POLYGON_MUMBAI = 'POLYGON_MUMBAI',
	GNOSIS_CHIADO = 'GNOSIS_CHIADO',
}

export enum EQueueStatus {
	PENDING = 'PENDING',
	IN_PROGRESS = 'IN_PROGRESS',
	SUCCESS = 'SUCCESS',
	ERROR = 'ERROR',
	BYPASSED = 'BYPASSED',
}

export enum EProjectTechnology {
	THERMAL_SOLAR = 'THERMAL_SOLAR',
	PHOTOVOLTAIC = 'PHOTOVOLTAIC',
	WIND = 'WIND',
	BIOMASS = 'BIOMASS',
	CIRCULARITY = 'CIRCULARITY',
	HEAT_PUMP = 'HEAT_PUMP',
	FATAL_HEAT = 'FATAL_HEAT',
	LOW_CARBON_MATERIAL = 'LOW_CARBON_MATERIAL',
	UNSPECIFIED = 'UNSPECIFIED',
}

export enum EAco2OpsStatus {
	HELD = 'HELD',
	BURNT = 'BURNT',
}

export enum EAddiOpsStatus {
	HELD = 'HELD',
	STACKED = 'STACKED',
	UNSTACKED = 'UNSTACKED',
	BURNT = 'BURNT',
}

export enum EProductionStatus {
	AVAILABLE = 'AVAILABLE',
	LOCKED = 'LOCKED',
	MINTED = 'MINTED',
}

export enum EMediaType {
	FILE = 'FILE',
	IMAGE = 'IMAGE',
	VIDEO = 'VIDEO',
	AUDIO = 'AUDIO',
	TEXT = 'TEXT',
}

export enum EImportStatus {
	IN_PROGRESS = 'IN_PROGRESS',
	SUCCESS = 'SUCCESS',
	ERROR = 'ERROR',
	ROLLED_BACK = 'ROLLED_BACK',
}

export enum EModelsWithPrivateMedia {
	ADDITIONALITY = 'Additionality',
	MEASURABILITY = 'Measurability',
	CERTIFICATE = 'Certificate',
}

export enum EPrivateBuckets {
	PRIVATE = 'private',
	CERTIFICATES = 'certificates',
}

export enum EPublicBuckets {
	STATICS = 'statics',
}
